module.exports = __webpack_public_path__ + "img/face79.5f8c4e40.gif";